import { createSlice } from '@reduxjs/toolkit';
import { createNewOrder, createNewOrderForWallet } from './orderServices';

const initialState = {
    orderDetails: {
        isOrderCreating: null,
        isOrderSuccess: null,
        orderMessage: null,
        orderResponse: null,
    },

    walletOrderDetails: {
        isWalletOrderCreating: null,
        isWalletOrderSuccess: null,
        walletOrderMessage: null,
        walletOrderResponse: null,
    }
}

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createNewOrder.pending, (state) => {
                state.orderDetails = {
                    ...initialState.orderDetails,
                    isOrderCreating: false,
                    orderMessage: 'Creating the order...',
                };
            })
            .addCase(createNewOrder.rejected, (state, action) => {
                state.orderDetails = {
                    ...initialState.orderDetails,
                    isOrderCreating: false,
                    isOrderSuccess: false,
                    orderMessage: action.payload.message,
                };
            })
            .addCase(createNewOrder.fulfilled, (state, action) => {
                state.orderDetails = {
                    ...initialState.orderDetails,
                    isOrderCreating: false,
                    isOrderSuccess: true,
                    orderMessage: action.payload.message,
                    orderResponse: action.payload.order
                };
            });
        builder
            .addCase(createNewOrderForWallet.pending, (state) => {
                state.walletOrderDetails = {
                    ...initialState.walletOrderDetails,
                    isWalletOrderCreating: true,
                    walletOrderMessage: 'Creating the order...',
                };
            })
            .addCase(createNewOrderForWallet.rejected, (state, action) => {
                state.walletOrderDetails = {
                    ...initialState.walletOrderDetails,
                    isWalletOrderCreating: false,
                    isWalletOrderSuccess: false,
                    walletOrderMessage: action.payload.message,
                };
            })
            .addCase(createNewOrderForWallet.fulfilled, (state, action) => {
                state.walletOrderDetails = {
                    ...initialState.walletOrderDetails,
                    isWalletOrderCreating: false,
                    isWalletOrderSuccess: true,
                    walletOrderMessage: action.payload.message,
                    walletOrderResponse: action.payload.order
                };
            })
    }
});

export default orderSlice.reducer;